import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  declare inputTarget: HTMLInputElement

  generate() {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789"
    const array = new Uint8Array(6)
    crypto.getRandomValues(array)
    const random = Array.from(array)
      .map((b) => chars[b % chars.length])
      .join("")
    this.inputTarget.value = `HIDEOUT-${random}`
  }
}
